import BaseQuery from "../BaseQuery";


export default class GetTenantByIdQuery extends BaseQuery {
    public id: string;
    constructor(id: string) {
        super()
        this.id = id
    }

    public override ConstructQueryString() : void {
        
    }
    
    public GetEndpoint(): string {
        return "tenant/tenant/" + this.id
    }
}